import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Headline } from '../../atoms';
import { Header } from '../../organisms/Header/Header';
import classes from './Error.module.scss';

export function ErrorPage({ message: initialMessage }: { message?: string }) {
  const navigate = useNavigate();

  const location = useLocation();

  const message = location.state?.message || initialMessage || '';

  return (
    <React.Fragment>
      <Header />
      <div className={classes.Error}>
        <Headline level={3}>Fehler</Headline>
        <div>{message}</div>
        <div className={classes['button-container']}>
          <Button onClick={() => navigate('/dashboard')}>Zum Dashboard</Button>
        </div>
      </div>
    </React.Fragment>
  );
}
